<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <CDataTable
        striped
        hover
        bordered
        small
        fixed
        :items="items"
        :fields="fields"
        :items-per-page="Number(50)"
        :noItemsView="noItems"
        style="flex: 1"
      >
        <template v-for="cel of fields" #[cel.key]="{item}">
          <td :style="item.style" :key="cel.key">{{ item[cel.key] }}</td>
        </template>
      </CDataTable>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import { makeCSS, formaters } from "./utils";
export default {
  name: "Table",
  components: {},
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },
  computed: {
    fields() {
      return this.estructura.map(m => ({
        key: m.expresion,
        label: m.etiqueta,
        _style: this.makeCSS(m)
      }));
    },
    items() {
      return this.data.map(m => {
        const style = this.makeCSS(m);
        const row = { style };
        this.estructura.forEach(item => {
          const value = m =>
            m[item.expresion]
              ? `${this.formaters(item)(m[item.expresion], item?.style)}${
                  item?.style?.sufijo ? ` ${item?.style?.sufijo}` : ""
                }`
              : " ";
          row[item.expresion] = value(m);
        });
        return row;
      });
    }
  },
  methods: {
    formaters(item) {
      return formaters(item?.style?.tipo);
    },
    makeCSS(v) {
      return makeCSS(v);
    }
  }
};
</script>

<style lang="scss" scoped>
.DashScrollContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
}
</style>
